function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var CACHE_VALID_TIME = 1000 * 60 * 60 * 12; // 12 hours

var STORAGE_NAME = 'tryCount';

var TryCountStorage = /*#__PURE__*/function () {
  function TryCountStorage() {
    _classCallCheck(this, TryCountStorage);
  }

  _createClass(TryCountStorage, null, [{
    key: "_haveLocalStorage",
    value: function _haveLocalStorage() {
      return typeof Storage !== 'undefined';
    }
  }, {
    key: "checkCache",
    value: function checkCache() {
      if (this._haveLocalStorage()) {
        var tryCount = localStorage.getItem(STORAGE_NAME);

        if (tryCount) {
          var tryCountStore = JSON.parse(tryCount);
          var now = Date.now();

          if (now - tryCountStore.time > CACHE_VALID_TIME) {
            localStorage.removeItem(STORAGE_NAME);
          }
        }
      }
    }
  }, {
    key: "increaseTryCount",
    value: function increaseTryCount() {
      if (this._haveLocalStorage()) {
        if (localStorage.getItem(STORAGE_NAME)) {
          var tryCountStore = JSON.parse(localStorage.getItem(STORAGE_NAME));
          var tryCount = {
            count: tryCountStore.count + 1,
            time: Date.now()
          };
          localStorage.setItem(STORAGE_NAME, JSON.stringify(tryCount));
        } else {
          localStorage.setItem(STORAGE_NAME, JSON.stringify({
            count: 1,
            time: Date.now()
          }));
        }
      }
    }
  }, {
    key: "resetTryCount",
    value: function resetTryCount() {
      if (this._haveLocalStorage()) {
        localStorage.setItem(STORAGE_NAME, JSON.stringify({
          count: 0,
          time: Date.now()
        }));
      }
    }
  }, {
    key: "getTryCount",
    value: function getTryCount() {
      if (this._haveLocalStorage() && localStorage.getItem(STORAGE_NAME)) {
        return JSON.parse(localStorage.getItem(STORAGE_NAME));
      }

      return null;
    }
  }]);

  return TryCountStorage;
}();

export { TryCountStorage as default };